import React from 'react';
import { Header } from '../components/Header';
import { Navigation } from '../components/Navigation';
import { MarketTicker } from '../components/MarketTicker';
import { MarketStrip } from '../components/MarketStrip';
import { HeroSection } from '../components/HeroSection';
import { BottomArticles } from '../components/BottomArticles';
import { AdPlaceholder } from '../components/AdPlaceholder';
export function Home() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-439">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-440">
        <Header data-id="element-441" />
        <Navigation data-id="element-442" />
      </div>

      {/* Full-width ticker bar */}
      <MarketTicker data-id="element-443" />

      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-444">
        {/* Top Banner Ad */}
        <div className="py-6 flex justify-center" data-id="element-445">
          <AdPlaceholder width="w-full max-w-[728px]" height="h-[90px]" text="Wenda Ingredients Advertisement" data-id="element-446" />
        </div>

        <main data-id="element-447">
          <HeroSection data-id="element-448" />
          <MarketStrip autoScroll data-id="element-449" />
          <BottomArticles data-id="element-450" />
        </main>

        {/* Bottom Banner Ad */}
        <div className="py-8 border-t border-gray-200 flex justify-center" data-id="element-451">
          <AdPlaceholder width="w-full max-w-[970px]" height="h-[90px]" text="Intralox Advertisement" data-id="element-452" />
        </div>
      </div>
    </div>;
}